import firebase from "firebase/app"
import "firebase/auth"
import 'firebase/firestore';
import * as firebaseui from 'firebaseui';


const config = {
    apiKey: "AIzaSyC62A3C4A7CV2vbhFILACUUs-hmJo-4xWk",
    authDomain: "wti-services-jrz.firebaseapp.com",
    projectId: "wti-services-jrz",
    storageBucket: "wti-services-jrz.appspot.com",
    messagingSenderId: "349483199281",
    appId: "1:349483199281:web:d7a78d85a348e57fdd9e10"
};

const uiConfig = {
    signInOptions: [
        firebase.auth.EmailAuthProvider.PROVIDER_ID,
        firebase.auth.GoogleAuthProvider.PROVIDER_ID,
    ],
    signInSuccessUrl: '/',
};

firebase.initializeApp(config);

export const auth = firebase.auth();
export const gprovider = new firebase.auth.GoogleAuthProvider();
export const fprovider = new firebase.auth.FacebookAuthProvider();
export const db = firebase.firestore();
firebase.firestore().enablePersistence()


// db.settings({
//     timestampsInSnapshots: true,
// });

export const startUi = (elementId) => {
    const ui = new firebaseui.auth.AuthUI(auth);
    ui.start(elementId, uiConfig);
}


// WEBPACK FOOTER //
// ./src/services/firebase/index.js